import { useEffect } from 'react'

/* eslint-disable */
console.useLog = (...args) => {
  useEffect(() => console['log'](...args), [args[args.length - 1]])
}
/* eslint-enable */
